import NamedDto from 'modules/base/dto/NamedDto';

export class LummusModelInputUnitOpEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.code = null;
		/** @type {string} */
		this.type_code = null;
	}

	/**
	 * @typedef {Object} _LummusModelInputUnitOpEditDtoProps
	 * @property {string} code
	 * @property {string} type_code
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _LummusModelInputUnitOpEditDtoProps} LummusModelInputUnitOpEditDtoProps
	 */
	/**
	 *
	 * @param {LummusModelInputUnitOpEditDtoProps} props
	 * @returns {LummusModelInputUnitOpEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.code = props.code;
		this.type_code = props.type_code;
		return this;
	}
}

export default LummusModelInputUnitOpEditDto;
